export const photos = [
    {
        src: require("./static/pics/displayed/SAMPLE.png"),
        width: 10,
        height: 10,
        title: {
            zh: '指导书样例',
            us: 'Sample Instructions',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_1.png"),
        width: 4,
        height: 3,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_2.png"),
        width: 5,
        height: 3,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_3.png"),
        width: 3,
        height: 5,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_4.png"),
        width: 3,
        height: 5,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_5.png"),
        width: 3,
        height: 5,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_6.png"),
        width: 4,
        height: 2,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_7.png"),
        width: 5,
        height: 3,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_8.png"),
        width: 4,
        height: 3,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_9.png"),
        width: 5,
        height: 3,
        title: {
            zh: '',
            us: '',
        }
    },
    {
        src: require("./static/pics/displayed/IMG_10.png"),
        width: 5,
        height: 3,
        title: {
            zh: '',
            us: '',
        }
    }
]